import React from "react";
import SvgIcn from "../../../data/IconCompo";
import PropTypes from "prop-types";

const PriceSelector = ({ priceOptions, selectedPrice, onChange }) => {
  return (

      <div className="price-group">
        {priceOptions.map((price) => (
          <label
            key={price.value}
            className={`price-option ${
              selectedPrice?.toLowerCase() === price?.value?.toLowerCase()
                ? "selected"
                : ""
            }`}
          >
            <input
              type="radio"
              name="price"
              value={price.value}
              checked={selectedPrice === price.value}
              onChange={() => onChange(price.value)}
              style={{ display: "none" }}
            />
            <SvgIcn name={price.icon} />
            {/* <span>{price.label}</span> */}
          </label>
        ))}
      </div>

  );
};

PriceSelector.propTypes = {
  priceOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedPrice: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PriceSelector;
